import { actionTypes, mutationTypes } from '@/core/constants'
import api from '@/core/apiclient'
import {DownloadFile} from "@/core/utils";

export default {
	async [actionTypes.PEDIDO.BUSCAR_INFORMACOES]({ commit }, idAta) {
		const { data } = await api.pedido.buscarInformacoesPorIdPedido(idAta)
		commit(mutationTypes.PEDIDO.SET_INFORMACOES, data)
		return data
	},
	async [actionTypes.PEDIDO.CALCULAR_TOTAL](context, idPedido) {
		const { data } = await api.pedido.calcularTotalPedido(idPedido)
		return data
	},
	async [actionTypes.PEDIDO.SALVAR_PEDIDO](context, salvarPedidoInput) {
		await api.pedido.salvarPedido(salvarPedidoInput)
	},
	async [actionTypes.PEDIDO.SALVAR_NUMERO_PEDIDO](context, salvarPedidoInput) {
		await api.pedido.salvarNumeroPedido(salvarPedidoInput)
	},
	async [actionTypes.PEDIDO.SALVAR_ITENS_EM_RASCUNHO](context, salvarItensEmRascunhoPedidoInput) {
		const { data } = await api.pedido.salvarPedidoComItensEmRascunho(salvarItensEmRascunhoPedidoInput)
		return data
	},
	async [actionTypes.PEDIDO.REMOVER_ITENS_EM_RASCUNHO](context, removerItensEmRascunhoPedidoInput) {
		const { data } = await api.pedido.removerItensEmRascunho(removerItensEmRascunhoPedidoInput)
		return data
	},
	async [actionTypes.PEDIDO.EXCLUIR_PEDIDO](context, idPedido) {
		await api.pedido.excluirPedido(idPedido)
	},
	async [actionTypes.PEDIDO.AUTORIZAR_PEDIDO](context, idPedido) {
		await api.pedido.autorizarPedido(idPedido)
	},
	async [actionTypes.PEDIDO.NAO_AUTORIZAR_PEDIDO](context, idPedido) {
		await api.pedido.naoAutorizarPedido(idPedido)
	},
	async [actionTypes.PEDIDO.CONCLUIR_PEDIDO](context, idPedido) {
		await api.pedido.concluirPedido(idPedido)
	},
	async [actionTypes.PEDIDO.EFETIVAR_PEDIDO](context, idPedido) {
		await api.pedido.efetivarPedido(idPedido)
	},
	async [actionTypes.PEDIDO.INTEGRACAO.ENVIAR](context, idPedido) {
		await api.pedido.enviarPedidoIntegracao(idPedido)
	},
	async [actionTypes.PEDIDO.BUSCAR_ORGAOS_DO_USUARIO](context, idAta) {
		const { data } = await api.pedido.buscarOrgaosDoUsuario(idAta)
		return data
	},
	async [actionTypes.PEDIDO.BAIXAR_RELATORIO_PREVIO](context, idPedido) {
		const response = await api.pedido.baixarRelatorioPrevio(idPedido)
		const headers = response.headers
		DownloadFile.downloadArrayBuffer(response.data, headers.filename, headers['content-type'], headers.extension)
	},
	async [actionTypes.PEDIDO.BUSCAR_PEDIDO_POR_FILTRO]({ state }) {
		const {
			idOrgao,
			idAtividadePedido,
			filtro: { atividadePedido, ...filtro },
			paginacao,
		} = state

		const { data } = await api.pedido.buscarPedidosPorFiltro({ idOrgao, idAtividadePedido, ...filtro }, paginacao)
		return data
	},
	async [actionTypes.PEDIDO.BUSCAR_PEDIDO_ORGAOS]() {
		const { data } = await api.pedido.buscarPedidoOrgaos()
		return data
	},
	async [actionTypes.PEDIDO.BUSCAR_ALMOXARIFADOS](context, idPedido) {
		const { data } = await api.pedido.buscarAlmoxarifados(idPedido)
		return data
	},
	async [actionTypes.PEDIDO.PROTOCOLO.BUSCAR_ESPECIES_DOCUMENTAIS]() {
		const { data } = await api.pedido.buscarEspeciesDocumentaisProtocolo()
		return data
	},
	async [actionTypes.PEDIDO.PROTOCOLO.PROTOCOLAR](context, { idPedido, dadosProtocolo }) {
		const { data } = await api.pedido.protocolarPedido(idPedido, dadosProtocolo)
		return data
	},
}
